export enum UPLOAD_TYPE {
  ASSET = 1,
  DRIVER = 2,
  USER = 3,
  FLEET_TAG = 4,
  GROUPS = 5,
  GEOZONE = 6,
  VISIONMAX_CAMERA_MAPPING = 7,
  ZIP_TIE = 8,
}

export const UPLOAD_TYPE_OBJ = [
  { label: "Asset", value: 1 },
  { label: "Driver", value: 2 },
  { label: "User", value: 3 },
  { label: "FleetTag", value: 4 },
  { label: "Groups", value: 5 },
  { label: "Geozone", value: 6 },
  { label: "FleetVision Camera Mapping", value: 7 }, // VisionMax is called FleetVision in the UI
  { label: "Serialized Zip Tie", value: 8 },
];
